module.exports = __webpack_public_path__ + "img/hotel-22.af44d6ce.jpeg";